/* global axios */
import AsteriskApiClient from './index';

class HealthAPI extends AsteriskApiClient {
  constructor() {
    super('health');
  }

  // GET /api/v1/accounts/:account_id/asterisk_aci/health
  get() {
    return axios.get(this.url);
  }
}

export default new HealthAPI();
